import React from 'react';
import { Button } from '../ui/button';

const AgeStep = ({ data, updateData, onNext }) => {
  const ageRanges = ['18-25', '26-30', '31-40', '41-50', '50+'];

  const handleSelect = (age) => {
    updateData('age', age);
    setTimeout(() => onNext(), 300);
  };

  return (
    <div className="text-center">
      <h1 className="text-white text-2xl md:text-3xl font-bold mb-12">
        How old is she?
      </h1>

      <div className="space-y-4 mb-8">
        {ageRanges.map((range) => (
          <button
            key={range}
            onClick={() => handleSelect(range)}
            className={`w-full py-4 px-6 rounded-full text-lg font-bold transition-all duration-300 hover:scale-105 ${
              data.age === range
                ? 'bg-[#F1B428] text-black shadow-lg shadow-[#F1B428]/30 scale-105'
                : 'bg-white/5 backdrop-blur-sm text-white border border-white/10 hover:border-[#F1B428]/50'
            }`}
          >
            {range}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AgeStep;
